'use strict';
var ansiRegex = require('ansi-regex');
var re = new RegExp(ansiRegex().source); // remove the `g` flag
module.exports = re.test.bind(re);



//////////////////
// WEBPACK FOOTER
// ./~/has-ansi/index.js
// module id = 670
// module chunks = 2 3